import { useContext } from 'react';
import { ErrorHandlerContext } from '../contexts/error-handler.js';
export function useErrorHandler() {
    const context = useContext(ErrorHandlerContext);
    if (!context) {
        throw new Error('useErrorHandler must be used within an ErrorHandlerContext');
    }
    return context;
}
//# sourceMappingURL=use-error-handler.js.map